import React                                   from 'react';
import { ModalProps, SidebarProps }            from 'semantic-ui-react';
import { TogglableContentHook }                from '../hooks/useTogglableContentReducer';
import { ToastsHook, UseMouseCoordinatesHook } from '../hooks';
import { CorvalBusinessFunction }              from '@src/types';


export interface ThemeContextType {
    name?: string;
}


export interface TourContextType {
    showTour: boolean;
    setShowTour: ( value: boolean ) => void;
}

const TourContext = React.createContext<TourContextType>( {
    showTour:    false,
    setShowTour: () => {}
} );

TourContext.displayName = 'Tour';

export interface DynamicContentContextType {
    sidebar?: TogglableContentHook<SidebarProps>,
    modal?: TogglableContentHook<ModalProps>,
    toasts?: ToastsHook,
}

export interface SystemUtilObjects {
    logging?: any,
}

export interface SystemDataObjects {
    businessFunctions: CorvalBusinessFunction[],
}

export interface UIContextType {
    mouseCoordinates: UseMouseCoordinatesHook;
}

const ThemeContext             = React.createContext<ThemeContextType>( { name: 'Corval' } as ThemeContextType ),
      SystemUtilContext        = React.createContext<SystemUtilObjects>( { logging: null } as SystemUtilObjects ),
      SystemDataContext        = React.createContext<SystemDataObjects>( { businessFunctions: [] } as SystemDataObjects ),
      UIContext                = React.createContext<UIContextType>( {} as UIContextType ),
      DynamicComponentsContext = React.createContext<DynamicContentContextType>( { sidebar: null, modal: null, toasts: null } as DynamicContentContextType );

ThemeContext.displayName = "Theme";
DynamicComponentsContext.displayName = "DynamicComponents";
SystemUtilContext.displayName = "SystemUtilContent";
SystemDataContext.displayName = "SystemDataContext";
UIContext.displayName = "UIDetails";

export {
    DynamicComponentsContext,
    ThemeContext,
    SystemUtilContext,
    SystemDataContext,
    UIContext,
    TourContext
};
